import { StrictMode } from "react"
import { createRoot } from "react-dom/client"

import "./index.css"
import "blobatar/motion.css"
import App from "./App.tsx"
import { ThemeProvider } from "@/components/theme-provider.tsx"
import { trackViewportHeight } from "@/lib/viewport"

trackViewportHeight()

// The app is a committed dark surface, so the shell opens dark rather than
// following the OS.
createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <ThemeProvider defaultTheme="dark">
      <App />
    </ThemeProvider>
  </StrictMode>
)
